module.exports = __webpack_public_path__ + "img/170224.f854dcfc.png";